<template>    
    <div class="submain__terrenos-custom torreairea_torre">
        <!-- <div class="line__vertical-mains"></div> -->
        <button-back/>
        <div class="select__box box-terrenos">
            <FilterMobile>
                <Range class="ranges-mobile" v-if="locations.length > 0 && rangeFilter.length > 0" :locations="locations" @change="changeRange" :rangeFilter="rangeSliderFilter" :rangeFilterPrice="rangeFilterPrice"/>  
            </FilterMobile>
                <Availables class="availables-mobile" :type="type" :existFilter="existFilter" :amountAvailables="amountAvailables" />
        </div>
        <div class="torreairea-terrenos">
            <Availables class="availables-desk availables-torreairea" :type="type" :existFilter="existFilter" :amountAvailables="amountAvailables" />
                <Range class="ranges-desk" v-if="locations.length > 0 && rangeFilter.length > 0" :locations="locations" @change="changeRange" :rangeFilter="rangeSliderFilter" :rangeFilterPrice="rangeFilterPrice"/>  
        </div>
        <div v-if="locations.length > 0" class="map_filter">
             
            <div class="maphighlight__box">
                
                <map-highlight  @activeDetail="showDetail" :img="img" :existFilter="existFilter" :desarrollo="desarrollo" :url="url" :type="type" :nivel="nivel" />
                <Button :img="img" :id="id" :desarrollo="desarrollo" :nivel="nivel" :levelId="levelId" :url="url" />
                <div class="line_horizontal ranges-desk"></div>
                
            </div>
            <div class="select__box torrea">
                <!-- <Select v-if="locations.length > 0 && rangeFilter.length > 0" :locations="locations" @change="changeRange" :rangeFilter="rangeFilter" /> -->
                <div v-if="!detail">
                    <h1 class="caption__select torrea">
                    <span>Seleccione un terreno, clic para ver detalles</span>
                </h1>
                </div>
                <div v-else>
                    <Terreno />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MapHighlight from "../../../core/rediseno/MapHighlightCasas.vue";
import ButtonBack from "../../../core/ButtonBack";
import Button from "../../../core/Button.vue";
import Availables from "../../../core/rediseno/Availables.vue";
//import Select from "../../../core/Select.vue";
import Range from "../../../core/Range.vue";
import Terreno from "./Terreno.vue"
import FilterMobile from "../../../core/rediseno/filter/FilterMobile.vue"

export default {
    name: "Main",
    components: {
        MapHighlight,
        Button,
        ButtonBack,
        Availables,
        //Select,
        Range,
        Terreno,
        FilterMobile
    }, 
    data() {
        return {
            id: 36,
            levelId: this.$route.params.id,
            type: "terreno",
            desarrollo: "canadas_terrenos-priv",
            arrFilteredLocations: [],
            nivel: "availability",
            url: `nombre_nivel_te=${this.$route.params.privada}/detalles`,
            micrositeUrl: "https://www.tresmarias.com.mx/senderos/terrenos",
            privadas: {
                PRIVADA14: {
                    name: 'privada14',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/terrenos/privadas/privada14.png',
                    width: '1350',
                    id: 36,
                    levelId: this.$route.params.id,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.privada}/detalles`,
                    height: '1889',
                    transform: '',
                    viewBox: '0 0 1350 1889'
                },
                PRIVADA15: {
                    name: 'privada15',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/terrenos/privadas/privada15.png',
                    width: '3552',
                    id: 36,
                    levelId: this.$route.params.id,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.privada}/detalles`,
                    height: '1441',
                    transform: '',
                    viewBox: '0 0 3552 1441'
                },
                PRIVADA22: {
                    name: 'privada22',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/terrenos/privadas/privada22.png',
                    width: '2252',
                    id: 36,
                    levelId: this.$route.params.id,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.privada}/detalles`,
                    height: '2032',
                    transform: '',
                    viewBox: '0 0 2252 2023'
                },
                PRIVADA28: {
                    name: 'privada28',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/ca%C3%B1adas/terrenos/privadas/privada28.png',
                    width: '3524',
                    id: 36,
                    levelId: this.$route.params.id,
                    nivel: 'availability',
                    route: `nombre_nivel_te=${this.$route.params.privada}/detalles`,
                    height: '1616',
                    transform: '',
                    viewBox: '0 0 3524 1616'
                },
                
            },
            rangeSliderFilterPriv15:[92,233],
            rangePriceFilterPriv15:[490000,1295000],
            rangeFilterPriv15: [
                { min: 92, max: 109.49 },
                { min: 112, max: 232.87 },
            ],
            rangeSliderFilterPriv22:[106,170],
            rangePriceFilterPriv22:[632200,1050000],
            rangeFilterPriv22: [
                { min: 106.05, max: 128 },
                { min: 140.02, max: 166.64 },
            ],
            rangeFilterPriv14: [
                { min: 106.05, max: 128 },
                { min: 140.02, max: 166.64 },
            ],
            rangeSliderFilterPriv14:[96,224],
            rangePriceFilterPriv14:[490000,873600],
            rangeFilterPriv28: [
                { min: 106.05, max: 128 },
                { min: 140.02, max: 166.64 },
            ],
            rangeSliderFilterPriv28:[96,224],
            rangePriceFilterPriv28:[800064,1236658],
            //add
            detail:false,
        };
    },
    computed: {
        ...mapGetters({
            locations: "getLocations",
            filterModelos: "getStatusFilterModelos"
        }),
        development() {
            return { id: this.id, level: this.levelId };
        },
        img() {
            const privada = this.$route.params.privada;
            const privadaSeleccionada = this.privadas[privada];
            return privadaSeleccionada;
        },
        amountAvailables() {
            const filteredAvailables = this.existFilter;
            const newArrfiltered = filteredAvailables.filter(
                (item) => item.status == 2
            );
            return newArrfiltered;
        },
        rangeFilter() {
            let selectRangeFileter
            if (this.$route.params.id == 210) {
                selectRangeFileter = this.rangeFilterPriv15
            } else if (this.$route.params.id == 211) {
                selectRangeFileter = this.rangeFilterPriv22
            }else if (this.$route.params.id == 154) {
                selectRangeFileter = this.rangeFilterPriv14
            }if (this.$route.params.id == 237) {
                selectRangeFileter = this.rangeFilterPriv28
            }
            return selectRangeFileter
        },
        rangeSliderFilter() {
            let selectRangeFileter
            if (this.$route.params.id == 210) {
                selectRangeFileter = this.rangeSliderFilterPriv15
            } else if (this.$route.params.id == 211) {
                selectRangeFileter = this.rangeSliderFilterPriv22
            }else if (this.$route.params.id == 154) {
                selectRangeFileter = this.rangeSliderFilterPriv14
            }if (this.$route.params.id == 237) {
                selectRangeFileter = this.rangeSliderFilterPriv28
            }
            return selectRangeFileter
        },
         rangeFilterPrice() {
            let selectRangeFileter
            if (this.$route.params.id == 210) {
                selectRangeFileter = this.rangePriceFilterPriv15
            } else if (this.$route.params.id == 211) {
                selectRangeFileter = this.rangePriceFilterPriv22
            }else if (this.$route.params.id == 154) {
                selectRangeFileter = this.rangePriceFilterPriv14
            }if (this.$route.params.id == 237) {
                selectRangeFileter = this.rangePriceFilterPriv28
            }
            return selectRangeFileter
        },
        existFilter() {
            let arrExistFilter;
            if (this.rangeFilter) {
                arrExistFilter = this.arrFilteredLocations;
            } else if (this.rangeFilter === false) {
                arrExistFilter = this.locations;
            }
            return arrExistFilter;
        },
    },
    methods: {
        ...mapActions(["getAvailableLocations", "clearCoords"]),
        changeRange(arrFilter) {
            this.arrFilteredLocations = arrFilter;
        },
        showDetail(){
      this.detail=true;
    }

    },
    async created() {
        await this.getAvailableLocations(this.development);
    },
    async beforeDestroy() {
        await this.clearCoords();
    },
    mounted() {}
};
</script>
<style>
@media (min-width:1201px){
    .box-terrenos{
        display: none;
    }
}
</style>
